import axios from 'axios';
import { SessionContextService } from '@fmr-ap137880/pi-security-context-client-nodejs';
import measurement from './measurement';
import utility from './utility';

export default {
  name: 'navHelper',
  mixins: [measurement, utility],
  data() {
    return {
      routeApiCallInProgress: false,
    };
  },
  methods: {
    navigate(stateName) {
      this.$router.push({ name: stateName }).catch(() => { });
    },
    handleNigo() {
      if (localStorage.getItem('contextKey')) {
        localStorage.removeItem('contextKey');
      }
      if (localStorage.getItem('transactionContextKey')) {
        localStorage.removeItem('transactionContextKey');
      }
      const { tStoreResponse } = this.$globalData;

      if (this.routeId === 'iStock') {
        window.location.assign(`${this.rc_exitUrl}?ACCTSTATUS=N`);
      } else if (tStoreResponse && tStoreResponse.params && tStoreResponse.nigoURL) {
        Object.assign(tStoreResponse.params, { xtracId: this.rc_workItem });
        if (tStoreResponse.nigoURL.method === 'GET') {
          // Navigate to NIGO url
          window.location.href = tStoreResponse.nigoURL.url;
        } else {
          // Form submit to NIGO url
          this.submitForm(this.createForm(tStoreResponse.nigoURL.url, tStoreResponse.params));
        }
      } else {
        this.navigate(this.cs_stateName);
      }
    },
    handleIgo() {
      if (localStorage.getItem('contextKey')) {
        localStorage.removeItem('contextKey');
      }
      if (localStorage.getItem('transactionContextKey')) {
        localStorage.removeItem('transactionContextKey');
      }
      const { tStoreResponse } = this.$globalData;
      if (tStoreResponse && tStoreResponse.params && tStoreResponse.igoURL) {
        Object.assign(tStoreResponse.params, { accountNumber: this.rc_accountNumber, xtracId: this.rc_workItem });
        if (tStoreResponse.igoURL.method === 'GET') {
          // Navigate to IGO url
          window.location.href = tStoreResponse.igoURL.url;
        } else {
          // Form submit to IGO url
          this.submitForm(this.createForm(tStoreResponse.igoURL.url, tStoreResponse.params));
        }
      } else {
        this.navigate(this.cs_stateName);
      }
    },
    handleError(error) {
      let page;
      if ((error.response && error.response.status === 405) || error.message === 'Network Error') {
        page = 'session-timeout';
      } else {
        page = 'system-error';
      }
      this.navigate(page);
    },
    handleStatus(response, status) {
      this.track(`${status.toLowerCase()}-response`, 'interaction');
      this.setRenderData(response.data);
      if (response.data.instanceData.referrerContext.acctNum && (status === 'SUCCESSFUL' || status === 'IGO') && this.rc_accountNumber) {
        if (
          this.$globalData?.tStoreResponse?.igoURL
          && response?.data?.instanceData?.currentState?.savedTStoreRes?.igoURL
          && this.$globalData.tStoreResponse.igoURL.url !== response.data.instanceData.currentState.savedTStoreRes.igoURL.url
        ) {
          this.$globalData.tStoreResponse.igoURL.url = response.data.instanceData.currentState.savedTStoreRes.igoURL.url;
        }
        const ctx = new SessionContextService();
        if (this.uc_isMemberOrNonRetail) {
          this.routeApiCallInProgress = true;
          const sessionEnv = this.rc_isProd ? 'Prod' : 'NonProd';
          ctx.waitAndUpdateFACCookie(sessionEnv).then(() => {
            this.handleIgo();
          });
        } else {
          this.routeApiCallInProgress = false;
          this.handleIgo();
        }
      } else {
        this.handleNigo();
      }
    },
    routeEngine(instanceData, haltNavigation = false) {
      if (!this.routeApiCallInProgress) {
        this.routeApiCallInProgress = true;
        axios.post('api/route', { instanceData })
          .then((response) => {
            const acctStatus = response.data.instanceData.referrerContext
              ? response.data.instanceData.referrerContext.acctStatus : undefined;
            if (acctStatus) {
              if (!haltNavigation) {
                this.handleStatus(response, acctStatus);
              }
            } else {
              this.setRenderData(response.data);
              this.navigate(this.cs_stateName);
            }
            this.routeApiCallInProgress = false;
          }).catch((error) => {
            this.routeApiCallInProgress = false;
            this.handleError(error);
          });
      }
    },
  },
};
